import { render, staticRenderFns } from "./Chimpvolution.vue?vue&type=template&id=6a767510&scoped=true&"
import script from "./Chimpvolution.vue?vue&type=script&lang=ts&"
export * from "./Chimpvolution.vue?vue&type=script&lang=ts&"
import style0 from "./Chimpvolution.vue?vue&type=style&index=0&id=6a767510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a767510",
  null
  
)

export default component.exports